var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecoIco1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 16.129,
    width: 35.6183,
    height: 3.36021,
    fill: "#474EFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.40828,
    y: 4.02816,
    width: 35.6183,
    height: 3.36021,
    transform: "rotate(45 6.40828 4.02816)",
    fill: "#474EFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19.4892,
    width: 35.6183,
    height: 3.36021,
    transform: "rotate(90 19.4892 0)",
    fill: "#474EFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 31.5942,
    y: 6.40419,
    width: 35.6183,
    height: 3.36021,
    transform: "rotate(135 31.5942 6.40419)",
    fill: "#474EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecoIco1);
export default __webpack_public_path__ + "static/media/decoIco1.856522ea299663a27c44539b4a02918d.svg";
export { ForwardRef as ReactComponent };